import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, Output, EventEmitter, Input, OnChanges, SimpleChanges } from '@angular/core';

import { isNullOrUndefined } from '@app/util/util';
import { Icon, IconFillColor } from '@design-system/components/atoms/icon/entities/icon.types';
import {
  TypographyColor, TypographyFontFamily, TypographyFontSize
} from '@design-system/components/atoms/typography/entities/typography.types';
import { TypographyDsComponent } from '@design-system/components/atoms/typography/typography.component';
import { IconDsComponent } from '@design-system/components/atoms/icon/icon.component';

@Component({
  selector: 'app-ds-button-snippet',
  templateUrl: './button-snippet.component.html',
  styleUrls: ['./button-snippet.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    TypographyDsComponent,
    IconDsComponent,
  ]
})
export class ButtonSnippetDsComponent implements OnChanges {

  @Input() defaultValue = 0;
  @Input() isDisabled = false;
  @Input() minValue = 0;
  @Input() maxValue = null;

  @Output() emitValue: EventEmitter<number> = new EventEmitter<number>();

  public snippetValue = 0;

  public readonly add = Icon.Add;
  public readonly substract = Icon.Substract;

  public readonly typographyFontSizeXXS = TypographyFontSize.XXS;
  public readonly typographyFontFamilySemiBold = TypographyFontFamily.SemiBold;

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.defaultValue) {
      this.snippetValue = changes.defaultValue.currentValue;
    }
  }

  get typographyColor(): TypographyColor {
    return this.isDisabled ? TypographyColor.Disabled : TypographyColor.Primary;
  }

  get canIncrease(): boolean {
    return isNullOrUndefined(this.maxValue) ? !this.isDisabled : (!this.isDisabled && this.snippetValue < this.maxValue);
  }

  get canSubstract(): boolean {
    return !this.isDisabled && this.snippetValue > this.minValue;
  }

  public iconFillColor(controlIsOff: boolean): IconFillColor {
    return controlIsOff ? IconFillColor.Disabled : IconFillColor.Primary;
  }

  public modify(increase: boolean): void {
    if (!this.isDisabled) {
      if (increase) {
        if (!isNullOrUndefined(this.maxValue)) {
          this.snippetValue = this.canIncrease ? this.snippetValue + 1 : this.snippetValue;
        } else {
          this.snippetValue = this.snippetValue + 1;
        }
      } else {
        this.snippetValue = this.canSubstract ? this.snippetValue - 1 : this.snippetValue;
      }
      this.emitValue.emit(this.snippetValue);
    }
  }

}
